/**
 * Created by Carsten Bühler on 24.10.2016.
 */

import L from 'external/leaflet';
import featureUtils from '../utils/feature-util';
import { boIcon } from '../utils/icons';

const stateColors = {
    unknown: '#676a6c',
    green: '#79e14b',
    yellow: '#ffe700',
    orange: '#ffad00',
    red: '#f00000',
};

export const DEFAULT_LINE = {
    weight: 6,
    opacity: 1,
    dashArray: '20, 8',
    dashStyle: {
        color: '#676a6c'
    }
};

export const HIGHLIGHT_DEFAULT_LINE = {
    ...DEFAULT_LINE,
    weight: 10,
};

export const DEFAULT_POLYGON = {
    ...DEFAULT_LINE,
    weight: 5,
};

export const HIGHLIGHT_DEFAULT_POLYGON = {
    ...DEFAULT_LINE,
    weight: 8,
    fillOpacity: 0.4
};

const RedIcon = L.Icon.extend({
    options: {
        iconUrl: '/map-portlet/assets/marker-icon-red.png',
        popupAnchor: [0, -50],
        iconSize: [25, 41],
        iconAnchor: [12, 41]
    }
});

export class DefaultFeatureRenderer {
    constructor(){
        this.icon = new L.Icon.Default();
        this.highlightIcon = new RedIcon();
        this.line = DEFAULT_LINE;
        this.highlightLine = HIGHLIGHT_DEFAULT_LINE;
        this.polygon = DEFAULT_POLYGON;
        this.highlightPolygon = HIGHLIGHT_DEFAULT_POLYGON;
    }

    createFeatureLayer(feature, options){
        const { highlight, collapsed } = options;

        let layer;

        if (collapsed) {
            layer = this.createCollapsedLayer(feature, options);
        } else {
            layer = this.createLayer(feature, options);
        }

        if (featureUtils.isMarker(layer)) {
            this.styleMarker(layer, feature, highlight);
        } else {
            this.styleGeometry(layer, feature, highlight);
        }

        return layer;
    }

    createLayer(feature, options){
        return L.GeoJSON.geometryToLayer(feature, { bubblingMouseEvents: true, markersInheritOptions: true });
    }

    createCollapsedLayer(feature, options){
        const layer = L.GeoJSON.geometryToLayer(feature, { bubblingMouseEvents: true, markersInheritOptions: true });
        return L.marker(layer.getBounds().getCenter(), {bubblingMouseEvents: true, markersInheritOptions: true});
    }

    styleMarker(layer, feature, highlight){
        let { type, overallState, typeKey, gaugingStationTypeKey } = feature.properties;

        if (overallState) {
            overallState = typeof overallState === 'string' ? overallState : overallState.state.stateKey;
        }

        const icon = boIcon(type, typeKey || gaugingStationTypeKey, highlight, overallState);

        if (highlight) {
            this._highlightMarker(layer, (icon || this.highlightIcon));
        } else {
            this._renderMarker(layer, (icon || this.icon));
        }
    }

    styleGeometry(layer, feature, highlight){
        let { overallState } = feature.properties;
        let color = '#3388ff';

        if (overallState) {
            overallState = typeof overallState === 'string' ? overallState : overallState.state.stateKey;
            color = stateColors[overallState];
        }

        let style = this.line;
        if (featureUtils.isPolygon(layer, feature)) {
            style = highlight ? this.highlightPolygon : this.polygon;
        } else if (featureUtils.isLine(layer, feature)) {
            style = highlight ? this.highlightLine : this.line;
        }
        layer.setStyle({
            ...style,
            color,
            fillColor: color
        });
    }

    _renderMarker(layer, icon){
        layer.setZIndexOffset(0);
        layer.setIcon(icon);
    }

    _highlightMarker(layer, highlightIcon){
        layer.setZIndexOffset(1000);
        layer.setIcon(highlightIcon);
    }

}

export default DefaultFeatureRenderer;



// WEBPACK FOOTER //
// ./js/FeatureRenderer/DefaultFeatureRenderer.js